import { z } from "zod"
import { ZOD_ERROR_CODE } from "utils/constants"

function ValidateApiSchema<Z extends z.ZodTypeAny = z.ZodNever>(response: { data: object }, schema: Z) {
	if (!response?.data) throw new Error("No response data!")
	const parsed = schema.safeParse(response.data)
	if (!parsed.success) {
		throw new Error([ZOD_ERROR_CODE,parsed.error].join("\n"))
	}
	else return parsed.data
}

export default ValidateApiSchema